var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.colunas,"outlined":"","item-text":"descricao","item-value":"valor","dense":"","hide-details":"","label":"Campo Data","return-object":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }